import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../../lib/api";

/** Checks the current path against server-side redirects and navigates.
 *  Since this is a SPA, we intercept on route change and use navigate() with replace. */
let cache = null;
let cachePromise = null;

const loadRedirects = () => {
  if (cache) return Promise.resolve(cache);
  if (cachePromise) return cachePromise;
  cachePromise = api
    .get("/public/redirects")
    .then((r) => { cache = r.data || []; return cache; })
    .catch(() => { cache = []; return cache; })
    .finally(() => { cachePromise = null; });
  return cachePromise;
};

const RedirectsHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    loadRedirects().then((list) => {
      const match = list.find((r) => r.from_path === location.pathname);
      if (match) {
        if (/^https?:\/\//.test(match.to_path)) {
          window.location.replace(match.to_path);
        } else {
          navigate(match.to_path, { replace: true });
        }
      }
    });
  }, [location.pathname, navigate]);

  return null;
};

export default RedirectsHandler;
